'use client';

import { createContext } from 'react';

import type { TableRootContextInterface } from '../types/table-root.types';

export const TableRootContext = createContext<TableRootContextInterface>({});

TableRootContext.displayName = 'Table.Root.Context';
